import { reducer } from 'redux-clerk2'
import reduceReducers from 'reduce-reducers'
const notifsReducer = reducer({
	actionPrefix: 'NOTIFICATIONS',
});

const notifs = reduceReducers(notifsReducer)

export default notifs